export default __webpack_public_path__ + "static/media/Series-8600-8700-MPNH-Inline.29b78d96.png";